/** Attendee-related helpers
 * 
 * Extracting attendee-ish data from the following:
 *  - Attendee items
 *  - Meeting items with Booker/Attendee data
 *  - Meeting colleagues (More like Attendee items?)
 */


/** Meetings don't currently include all the Attendee fields, so we have to guess based on the names
 * @param {string} name  - Fullname
 * @returns {string} - 1-2 characters
 */
 export const nameInitials = (name) => {
  const allNames = name.trim().split(' ');
  const initials = allNames.reduce((acc, curr, index) => {
    if(index === 0 || index === allNames.length - 1){
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, '');
  return initials;
};

/** Meetings don't currently include all the Attendee fields, so we have to guess based on the names
 * @param {item} Object - Attendee/Meeting/Colleague dict
 * @returns {string} - 1-2 characters
 */
export const attendeeInitials = (item) => {
    console.log(item);
    return "??";
};



/** attendee can be any object with full_name and organisation_name fields 
 * If 'Solo' both fields will have the same value.
*/
export const nameAndOrganisation = (attendee) => {
  if (attendee.full_name == attendee.organisation_name) {
    // Solo, so just return the name
    return attendee.full_name;
  } else {
    return `${attendee.full_name} (${attendee.organisation_name})`;
  }
};